import { setUser } from "@sentry/nextjs";

import { inspectorAuthInteractor } from "@/client/amplify/auth";
import { analysisUserPropertyKeys, setAnalysisUserProperty } from "@/utils/analysis/analysis";
import { getFactoryId } from "@/utils/auth/getFactoryId";
import { makeSequentialComponent as makeSC } from "@/utils/sequential-component";
import { withRouting } from "./withRouting";

export type ComponentWithClientIdProps = {
  clientId: string;
};

/**
 * ログイン状態か確認するHOC
 */
export const withClientId = (Component: React.FC<ComponentWithClientIdProps>) =>
  makeSC(
    async () => {
      const props = await getClientId();
      setAnalysisUserProperty(analysisUserPropertyKeys.FACTORY_ID, props.clientId);
      setUser({ factoryId: props.clientId });
      return props;
    },
    {
      swr: false,
    },
  )(Component, withRouting("/auth"));

export const getClientId = (): Promise<ComponentWithClientIdProps> =>
  inspectorAuthInteractor.isSignIn().then(async (isSignIn) => {
    if (!isSignIn) {
      return Promise.reject("Not signed in");
    }
    const factoryId = await getFactoryId();
    if (!factoryId) {
      // SAMLログイン時にFACTORY_IDが指定されていない場合も考慮して明示的にログアウトする
      await inspectorAuthInteractor.signOut();
      return Promise.reject("Factory ID not found");
    }
    return { clientId: factoryId };
  });
